module.exports = __webpack_public_path__ + "img/pic_score.e9bb1df7.png";